import {ManipulationEditor} from "./ManipulationEditor";
import {Handler} from "./Handler";

export class ResizeHandler extends Handler {

	/**
	 * @param {ProcessNodeEditor} parent parent editor
	 * @param {string} horizontalType - "left", "center", "right"
	 * @param {string} verticalType - "top", "middle", "bottom"
	 */
	constructor(parent, horizontalType, verticalType) {
		super(parent);
		this.horizontalType = horizontalType;
		this.verticalType = verticalType;
	}


	get x() {
		switch (this.horizontalType) {
			case "left": return this.parent.x - this.parent.coords.w/2;
			case "center": return this.parent.x;
			case "right": return this.parent.x + this.parent.coords.w/2;
		}
	}

	get y() {
		switch (this.verticalType) {
			case "top": return this.parent.y - this.parent.coords.h/2;
			case "middle": return this.parent.y;
			case "bottom": return this.parent.y + this.parent.coords.h/2;
		}
	}

	set x(val) {
		if (this.horizontalType === "left" || this.horizontalType === "right") {
			const dist = Math.round(Math.abs(this.parent.x - val));
			this.parent.coords.w = 2*dist;
		}
	}

	set y(val) {
		if (this.verticalType === "top" || this.verticalType === "bottom") {
			const dist = Math.round(Math.abs(this.parent.y - val));
			this.parent.coords.h = 2*dist;
		}
	}
}